import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const seasonsWordList = [
  "bloom",
  "cloud",
  "cold",
  "cool",
  "dry",
  "fall",
  "flood",
  "forecast",
  "freeze",
  "frost",
  "hot",
  "lightning",
  "night",
  "rain",
  "shadow",
  "shower",
  "sky",
  "spring",
  "storm",
  "summer",
  "thunder",
  "warm",
  "weather",
  "wet",
  "wind",
  "winter",
];

export const seasonsCollection: WordCollection = createCollection(
  "seasons",
  "Seasons & Weather",
  seasonsWordList,
  { icon: "weather-partly-cloudy", isWordlistViewable: true }, // Example icon
);
